
import { defineComponent } from "vue";
import AppHeader from "@/components/theme/AppHeader.vue";

export default defineComponent({
  components: { AppHeader },
});
